export default __webpack_public_path__ + "static/cham-bbe5c4c16b7be5f738e73b10b20ed59e.jpg";